import { TrashIcon } from "@heroicons/react/24/outline";

import { useTranslation } from "react-i18next";
import { bytesToSize } from "utils/format";

interface UploadedFileListProps {
  files: File[];
  onRemove: (file: File) => void;
}

export function UploadedFileList({ files, onRemove }: UploadedFileListProps) {
  const { t } = useTranslation();

  return (
    <div className="mt-5 space-y-2">
      <h5 className="font-medium">
        {files.length} {t("task.upload.selected-files")}
      </h5>
      <div className="max-h-40 overflow-y-auto">
        <ul>
          {files.map((file) => (
            <li key={file.name}>
              <div className="flex items-baseline justify-between space-x-5">
                <div className="flex items-center space-x-1 truncate">
                  <button type="button" className="" onClick={() => onRemove(file)}>
                    <TrashIcon className="size-4 text-red-400" />
                  </button>
                  <span className="truncate font-medium" title={file.name}>
                    {file.name}
                  </span>
                </div>
                <span className="min-w-fit">{bytesToSize(file.size)}</span>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
